import { track } from 'src/lib/analytics/utils';
import type { GiftType } from 'src/replicant/gifts';
import { analytics } from '@play-co/gcinstant';

export type GiftOrigin = 'hud' | 'launch' | 'menu';

export type GiftPopupCloseReason = 'close_x' | 'close_button' | 'close_invite';
type GiftSendFailureStep =
  | 'single-oa-message'
  | 'single-replicant-message'
  | 'mass-oa-message'
  | 'mass-replicant-message';

type GiftPopupAnalytics = {
  origin: GiftOrigin;
  collectableSendersCount: number;
  sendableReceiversCount: number;
};

////////////////////////////////////////////////////////////////////////////////
// The player has collected a gift energy from a LINE friend
////////////////////////////////////////////////////////////////////////////////
export function trackGiftCollect({
  gift,
  amount,
  sender,
}: {
  gift: GiftType;
  amount: number | undefined;
  sender: string;
}) {
  track('GiftCollect', {
    gift,
    amount,
    sender,
  });
}

export const trackGiftPopupOpen = (data: GiftPopupAnalytics) =>
  track('GiftPopupOpen', {
    popupId: 'popupGiftsList',
    ...data,
  });

export const trackGiftSendAll = (data: GiftPopupAnalytics) =>
  track('GiftSendAll', data);

export const trackGiftPopupClose = (data: {
  closeReason: GiftPopupCloseReason;
  giftsSentCount: number;
  giftsCollectedCount: number;
}) =>
  track('GiftPopupClose', {
    popupId: 'popupGiftsList',
    ...data,
  });

export const trackGiftSend = (data: {
  gift: GiftType;
  amount: number;
  receiver: string;
  origin: GiftOrigin;
  type: 'oa';
}) => track('GiftSend', data);

export const trackGiftSendAttempt = (data: {
  origin: GiftOrigin;
  isMassSent: boolean;
  messagesCount: number;
  gift: GiftType;
  type: 'oa';
}) => track('GiftSendAttempt', data);

export const trackGiftSendError = (data: {
  error: unknown;
  origin: GiftOrigin;
  isMassSent: boolean;
  messagesCount: number;
  gift: GiftType;
  step: GiftSendFailureStep;
}) => {
  const { error, ...eventProperties } = data;

  analytics.pushError(
    'GiftSendError',
    error as Record<string, unknown>,
    eventProperties,
  );
};
